export const ClientDashboard = {
  en: {
    'Show pass': 'Show pass',
    'Access pass': 'Access pass',
    'Access pass hint':
      'Hold the code up to the scanning device to enter or exit.',
    'QR-code will be valid': 'QR-code will be valid',
    s: 's',
    'Used today': 'Used today',
    'Valid until': 'Valid until',
    Purchased: 'Purchased',
    Close: 'Close',
  },
  uk: {
    'Show pass': 'Показати перепустку',
    'Access pass': 'Перепустка',
    'Access pass hint':
      'Піднесіть код до скануючого пристрою, щоб увійти або вийти.',
    'QR-code will be valid': 'Код буде дійсний',
    s: 'с',
    'Used today': 'Вже використано сьогодні',
    'Valid until': 'Діє до',
    Purchased: 'Придбано',
    Close: 'Закрити',
  },
};
